var map = {
	"./1-IMG_7551.jpg": 1231,
	"./2-IMG_7565.jpg": 5544,
	"./3-IMG_7555.jpg": 1531,
	"./4-IMG_7559.jpg": 1237,
	"./5-IMG_7547.jpg": 3492,
	"./6-IMG_7571.jpg": 7388
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8040;